import { StripeConnectActionsSkeleton } from "../loading/SkeletonBlocks.jsx";

export default function StripeConnectCard({
  connect,
  isLoading,
  error,
  actionBusy,
  onBeginOnboarding,
  onOpenDashboard,
}) {
  const ready = Boolean(connect?.ready);
  const started = Boolean(connect?.accountId);

  return (
    <section className="rounded-2xl border border-hc-surface-border bg-hc-surface p-6">
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h2 className="text-sm font-semibold tracking-[-0.15px] text-hc-text">
            Client payments
          </h2>
          <p className="mt-1 max-w-xl text-xs text-hc-text-dim">
            Set up payouts so you can get paid by clients and from program sales. You set prices
            in CAD; sales tax is added for clients at checkout.
          </p>
        </div>
        {ready ? (
          <span className="rounded-full border border-hc-success/35 bg-hc-success-muted px-2.5 py-0.5 text-xs font-medium text-hc-success">
            Ready
          </span>
        ) : started ? (
          <span className="rounded-full border border-hc-warning/35 bg-hc-warning-muted px-2.5 py-0.5 text-xs font-medium text-hc-warning">
            Setup incomplete
          </span>
        ) : (
          <span className="rounded-full border border-hc-surface-border px-2.5 py-0.5 text-xs font-medium text-hc-text-dim">
            Not connected
          </span>
        )}
      </div>

      {error && (
        <p className="mt-3 rounded-[10px] border border-hc-error/30 bg-hc-error/10 px-3 py-2 text-xs text-hc-error break-words">
          {error}
        </p>
      )}

      {isLoading ? (
        <StripeConnectActionsSkeleton />
      ) : (
        <div className="mt-4 flex flex-wrap gap-2">
          {!ready && (
            <button
              type="button"
              disabled={actionBusy}
              onClick={onBeginOnboarding}
              className="rounded-[10px] bg-hc-primary px-4 py-2 text-sm font-semibold text-white transition hover:opacity-90 disabled:opacity-50"
            >
              {actionBusy ? "Redirecting…" : started ? "Continue setup" : "Set up payouts"}
            </button>
          )}
          {started && (
            <button
              type="button"
              disabled={actionBusy}
              onClick={onOpenDashboard}
              className="rounded-[10px] border border-hc-surface-border-strong px-4 py-2 text-sm font-medium text-hc-text-muted transition hover:bg-white/5 disabled:opacity-50"
            >
              {actionBusy ? "Opening…" : "Payout dashboard"}
            </button>
          )}
          {ready && (
            <a
              href="/client-plans"
              className="rounded-[10px] border border-hc-surface-border-strong px-4 py-2 text-sm font-medium text-hc-text-muted transition hover:bg-white/5"
            >
              Manage client plans
            </a>
          )}
        </div>
      )}
    </section>
  );
}
